/**
 * klaviyo-trigger.js
 * ------------------
 * Delegated click handler: any element with a [data-klaviyo-form] attribute opens that Klaviyo
 * onsite form via the custom-trigger queue. Shared by the promo banner and the announcement-bar
 * "Learn more" so both use identical behaviour. The value can be the bare 6-char form id
 * (e.g. "Xqj7iL") or the "klaviyo-form-XXXXXX" class name — openForm needs the bare id.
 *
 * _klOnsite works before and after klaviyo.js loads (the SDK drains + keeps honouring the queue).
 * https://developers.klaviyo.com/en/docs/how_to_custom_trigger_a_popup_or_flyout_form
 */
(function () {
  if (window.__gcKlaviyoTrigger) return;
  window.__gcKlaviyoTrigger = true;

  document.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('[data-klaviyo-form]') : null;
    if (!el) return;
    e.preventDefault();

    var formId = (el.getAttribute('data-klaviyo-form') || '').replace(/^klaviyo-form-/, '');
    if (!formId) return;

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  });
})();
